<template lang="pug">
.container
  uploadFile(:url="url" :params="params" :mime_types="mimeTypes" :max_file_size="maxFileSizeLimit" @whenUpload="whenUpload" @successCallBackLater="uploadCallBack" @errorCallBackLater="errorCallBack")
</template>

<script>
import uploadFile from './uploadFile.vue'

export default {
  components: {
    uploadFile
  },
  data () {
    return {
      url: '/static/upload',
      params: {
        username: 'test',
        password: '258596',
        role: 0,
        state: 1
      },
      mimeTypes: 'application/pdf',
      maxFileSizeLimit: 1024
    }
  },
  methods: {
    whenUpload (msg) {
      console.log(msg)
    },
    uploadCallBack (uploader, file, responseObject) {
      console.log(responseObject)
    },
    errorCallBack (uploader, error) {
      console.log(error)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/test.vue